export const PAYMENT_METHOD_ALMA_LABEL = 'alma'
export const PAYMENT_METHOD_FLOA3X4X_LABEL = 'floa3x4x'
export const PAYMENT_METHOD_FLOA4X_LABEL = 'floa4x'
export const PAYMENT_METHOD_ONEY_LABEL = 'oney'
export const PAYMENT_METHOD_PLEDG_LABEL = 'pledg'

export const DELAYED_PAYMENT_TYPES = {
  [PAYMENT_METHOD_ALMA_LABEL]: true,
  [PAYMENT_METHOD_FLOA3X4X_LABEL]: true,
  [PAYMENT_METHOD_FLOA4X_LABEL]: true,
  [PAYMENT_METHOD_ONEY_LABEL]: true,
  [PAYMENT_METHOD_PLEDG_LABEL]: true
}

export const ORDERED_PAYMENT_METHODS = [
  'creditCard',
  'visa',
  'masterCard',
  'amex',
  PAYMENT_METHOD_ALMA_LABEL,
  PAYMENT_METHOD_FLOA3X4X_LABEL,
  PAYMENT_METHOD_FLOA4X_LABEL,
  PAYMENT_METHOD_ONEY_LABEL,
  PAYMENT_METHOD_PLEDG_LABEL,
  'paypal',
  'iDeal',
  'sofort',
  'leetchi',
  'lydia',
  'ancv',
  'postfinance',
  'postfinanceefinance'
]
